const { LRUCache } = require('lru-cache');

// Cache that holds up to 100 entries and expires them after 5 minutes
const cache = new LRUCache({
  max: 500,
  ttl: 5 * 60 * 1000, // 5 minutes in milliseconds
});

// Validate required parameters
const validateParams = params => {
  const required = ['listingId', 'start', 'end', 'perPage', 'page'];
  const missing = required.filter(key => !params?.[key]);

  if (missing.length > 0) {
    throw new Error(`Missing required parameters: ${missing.join(', ')}`);
  }

  if (!(params.start instanceof Date) || !(params.end instanceof Date)) {
    throw new Error('start and end must be Date objects');
  }
};

// Normalize date to nearest hour to make cache keys more stable
const normalizeDate = date => {
  if (!(date instanceof Date)) {
    throw new Error('normalizeDate requires a Date object');
  }
  const d = new Date(date);
  d.setMinutes(0);
  d.setSeconds(0);
  d.setMilliseconds(0);
  return d.toISOString();
};

// Create a cache key from the query parameters
const createCacheKey = params => {
  validateParams(params);
  const { listingId, start, end, perPage, page } = params;
  const uuid = listingId?.uuid || listingId;
  const normalizedStart = normalizeDate(start);
  const normalizedEnd = normalizeDate(end);
  return `${uuid}-${normalizedStart}-${normalizedEnd}-${perPage}-${page}`;
};

// Get cached timeslots if they exist and are not expired
export const getCachedTimeslots = params => {
  try {
    const key = createCacheKey(params);
    return cache.get(key);
  } catch (error) {
    console.error('Error getting cached timeslots:', error);
    return null;
  }
};

// Cache timeslots response
export const cacheTimeslots = (params, response) => {
  try {
    const key = createCacheKey(params);
    cache.set(key, response);
  } catch (error) {
    console.error('Error caching timeslots:', error);
  }
};
